import { render, staticRenderFns } from "./autoExclude.vue?vue&type=template&id=6a589a54&scoped=true"
import script from "./autoExclude.vue?vue&type=script&lang=js"
export * from "./autoExclude.vue?vue&type=script&lang=js"
import style0 from "./autoExclude.vue?vue&type=style&index=0&id=6a589a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a589a54",
  null
  
)

export default component.exports